module.exports = __webpack_public_path__ + "static/media/eppt-picturemark-l.cd6a3482.svg";